// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"932":"1aee6649","953":"1ec3b8d0"}[chunkId] + ".css";
};